export const setObjectDefaultValues = (type) => {
  switch (type) {
    case 'string':
      return ''
    case 'boolean':
      return false
    case 'multiSelect':
      return []
    case 'number':
      return 0

    default:
      break
  }
}

export const dateConverter = (time = 0) => {
  const myDate = new Date(time)
  const s = myDate.toLocaleDateString().split('/')
  return [s[1], s[0], s[2]].join('-')
}

export const dateConverterToStringMonth = (time = 0) => {
  const myDate = new Date(time)
  const monthStringArray = [
    'Jan.',
    'Feb.',
    'Mar.',
    'Apr.',
    'May',
    'Jun.',
    'Jul.',
    'Aug.',
    'Sep.',
    'Oct.',
    'Nov.',
    'Dec.',
  ]
  return `${myDate.getDate()} ${monthStringArray[myDate.getMonth()]} ${myDate.getFullYear()}`
}

export const dateformat = (dateip) => {
  const date = new Date(dateip)
  console.log(dateip)

  const formatted = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date)

  return formatted
}

export const dateformat1 = (dateStr) => {
  const [datePart, timePart] = dateStr.split(' ')
  const [day, month, year] = datePart.split('-')
  const [hours, minutes, seconds] = timePart.split(':')

  // Create date: month is 0-indexed in JS
  const date = new Date(year, month - 1, day, hours, minutes, seconds)

  const formatted = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date)

  return formatted
}

export const dateConverterToStringMonthWithDate = (time = 0) => {
  const myDate = new Date(time)
  const monthStringArray = [
    'Jan.',
    'Feb.',
    'Mar.',
    'Apr.',
    'May',
    'Jun.',
    'Jul.',
    'Aug.',
    'Sep.',
    'Oct.',
    'Nov.',
    'Dec.',
  ]

  // Get hours and minutes
  let hours = myDate.getHours()
  const ampm = hours >= 12 ? 'PM' : 'AM'

  // Convert to 12-hour format
  hours = hours % 12
  hours = hours ? hours : 12

  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = myDate.getMinutes().toString().padStart(2, '0')

  return `${myDate.getDate()} ${
    monthStringArray[myDate.getMonth()]
  } ${myDate.getFullYear()}, ${formattedHours}:${formattedMinutes} ${ampm}`
}

export const formatStringFirstLetterCapital = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
}

export const dateTimeConverter = (time = 0) => {
  const myDate = new Date(time)
  const d = myDate.toLocaleDateString().split('/')
  const t = myDate.toLocaleTimeString().split(' ')

  return [d[0], d[1], d[2]].join('-') + ' ' + t[0].slice(0, -3) + ' ' + t[1]
}

export const ISOToDate = (dateString) => {
  const d = dateString.split('T')[0].split('-')
  return [d[2], d[1], d[0]].join('-')
}

export const getUniqueListBy = (arr, key) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()]
}

export const epochToDate = (n) => {
  const initialDate = new Date(0)
  initialDate.setUTCMilliseconds(n)
  return initialDate
}

export const capitalize = (s) => {
  const str = s
  const str2 = str.charAt(0).toUpperCase() + str.slice(1)
  return str2
}

export const camelCaseToCapitalizedWords = (str) => {
  return str.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())
}

export const compareTwoStates = (state1, state2) => {
  return JSON.stringify(state1) === JSON.stringify(state2)
}

export const convertToTitleCase = (str) => {
  return str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const REGION_TYPES = {
  PROVINCE: 'PROVINCE',
  DIVISION: 'DIVISION',
  STATE: 'STATE',
}

export const MODE_CONSTANTS = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
}
